"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rc_tooltip_1 = require("rc-tooltip");
var React = require("react");
var Icon_1 = require("../Icon");
function Cooltip(props) {
    var iconName = 'information_circle2';
    var ovrlyClassName = props.tooltipType + '-tooltip';
    switch (props.tooltipType) {
        case 'error':
            iconName = 'error_circle2';
            break;
        case 'success':
            iconName = 'check_mark_circle2';
            break;
        case 'warn':
            iconName = 'warning_circle2';
            break;
        case 'info':
            iconName = 'information_circle2';
            break;
        default:
            ovrlyClassName = '';
            break;
    }
    var icon;
    var ovrly;
    if (ovrlyClassName === '') {
        ovrly = (React.createElement("div", null,
            React.createElement("div", { style: { display: 'inline-block', paddingLeft: 10, minWidth: 100 } }, props.tooltipContents)));
    }
    else {
        icon = React.createElement(Icon_1.Icon, { icon: iconName });
        ovrly = (React.createElement("div", null,
            React.createElement("div", { style: { display: 'inline-block', paddingLeft: 0, verticalAlign: 'top', width: 20 } }, icon),
            React.createElement("div", { style: { display: 'inline-block', paddingLeft: 10, minWidth: 100 } }, props.tooltipContents)));
    }
    var overlayStyle = props.hidden ? { display: 'none' } : { minWidth: 150 };
    return (React.createElement(rc_tooltip_1.default, { overlay: ovrly, overlayClassName: ovrlyClassName, overlayStyle: overlayStyle, placement: props.placement }, props.children));
}
exports.Cooltip = Cooltip;
//# sourceMappingURL=Cooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Cooltip/Cooltip.js
// module id = 581
// module chunks = 1